import { DatePipe } from '@angular/common';
import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EventCustomerValidationStatus } from '../../../../models/_enum-collections';
import { DocumentRawData } from '../../../../models/document-raw-data.model';
import { EventDocumentRejectionReason } from '../../../../models/event-document-rejection-reason.model';
import { EventPoeDocument } from '../../../../models/event-poe-document.model';
import { EventPreviewDetails } from '../../../../models/event-preview-details.model';
import { EventPreviewInput } from '../../../../models/event-preview-input.model';
import { EventRegistrationDocumentStatusRequest } from '../../../../models/event-registration-document-status-request.model';
import { EventRegistrationDocumentModel } from '../../../../models/event-registration-document.model';
import { EventRegistrationCustomerModel } from '../../../../models/event-registration.model';
import { FileContentModel } from '../../../../models/file-content.model';
import { RawDocumentDataConfig } from '../configs/event-preview-config';
import { CommonSharedModule } from '../../../common/shared.module';
import { UpdateEventDocumentsStatusRequest } from '../../../../models/update-event-documents-status-request.model';
import { EventDocumentStatus } from '../../../../models/event-document-status.model';
import { PreviewConfirmationFormComponent } from '../../../shared/preview-confirmation-form/preview-confirmation-form.component';
import { PreviewContentComponent } from '../../../shared/preview-content/preview-content.component';
import { EventEditService } from '../../../services/event-edit.service';

@Component({
  selector: 'app-event-preview',
  templateUrl: './event-preview.component.html',
  styleUrls: ['./event-preview.component.scss'],
  standalone: true,
  imports: [
    CommonSharedModule,
    PreviewConfirmationFormComponent,
    PreviewContentComponent
  ]
})
export class EventPreviewComponent implements OnInit {
  eventRawData!: DocumentRawData[];
  eventPreviewData!: EventPoeDocument;
  eventPreviewType!: string;
  eventDocumentTypeId!: number;
  eventRegistrationDocumentId!: number;

  @Input() eventPreviewInput!: EventPreviewInput;
  @Output() closePreviewModal = new EventEmitter<boolean>();
  @Output() reLoadList: EventEmitter<any> = new EventEmitter<any>();
  fileContentModel!: FileContentModel;
  isDocumentPreviewLoading = false;
  canShowEventPreviewModel!: boolean;
  eventId!: number;
  downloadSpin = true;
  index = 0;
  isEngDtl = false;
  isCustomerAck = false;
  eventIdList!: number[];
  eventIndex!: number;
  isApproveReject!: boolean;
  showApproveDeny!: boolean;
  msgsUsageDetails!: any[];
  modalTitle!: string;
  invoiceRejectionList!: EventDocumentRejectionReason[];
  invoiceRejectionModalDisplay!: boolean;
  hideNextPrevious!: boolean;
  datePipe = new DatePipe('en-US');

  invoiceDocumentType = 'POEInvoice';
  rollCallDocumentType = 'POETemplate';
  skuPurchaseTrialDocumentType = 'POESKUTrial';
  daPOETemplateDocumentType = 'DealAssociationTemplate';
  savedPoeDocumentType = 'savedPoe';
  sowPreviewType = 'SOW';

  documentUploadedDate!: Date;
  documentStatus!: string;
  surveyDate!: string;
  surveyStatus!: string;
  poeDetailsForm!: FormGroup;
  approvedCustomersList: string[] = [];
  showTypeChangeButtons!: boolean;
  selectedWorkshopCompletionDate!: Date;
  eventDocuments!: EventRegistrationDocumentModel;
  eventDocumentStatuses!: EventDocumentStatus[];
  showApproveRejectLoadder!: boolean;
  eventCustomers!: {
    eventId: number;
    eventCustomers: EventRegistrationCustomerModel[];
  }[];

  hasPreviewDataLoaded = false;
  disableAcceptRejectButtons!: boolean;

  constructor(private eventEditService: EventEditService) {}

  ngOnInit() {
    this.hideNextPrevious = this.eventPreviewInput.hideNextPrevious || false;
    this.canShowEventPreviewModel = true;
    this.eventId = this.eventPreviewInput.eventId;
    this.eventIdList = this.eventPreviewInput.eventIdList || [];
    this.eventIndex = this.eventIdList.indexOf(this.eventPreviewInput.eventId);
    this.showPreview(this.eventPreviewInput.eventId);
    this.getEventDocumentStatuses();
    this.eventCustomers = this.eventPreviewInput.eventCustomers || [];
    this.approvedCustomersList =
      this.eventCustomers &&
      this.eventCustomers != undefined &&
      this.eventCustomers.find(x => x.eventId == this.eventId)
        ? this.eventCustomers
            ?.find(x => x.eventId == this.eventId)
            ?.eventCustomers.filter(
              cus =>
                cus.eventCustomerValidationStatusId ==
                EventCustomerValidationStatus.Approved
            )
            .map(cus => cus.customerName) || []
        : [];

    this.eventPreviewType = this.preiviewType;
  }

  get preiviewType() {
    if (this.eventPreviewInput.isPoeInvoicePreview)
      return this.invoiceDocumentType;
    else if (this.eventPreviewInput.isRollCallPreview)
      return this.rollCallDocumentType;
    else if (this.eventPreviewInput.isSKUPurchaseTrialPreview)
      return this.skuPurchaseTrialDocumentType;
    else if (this.eventPreviewInput.isDAPOETemplate)
      return this.daPOETemplateDocumentType;
    else if (this.eventPreviewInput.isSOWPreview) return this.sowPreviewType;
    else if (this.eventPreviewInput.isSavedDocumentPreview)
      return this.savedPoeDocumentType;
    else return this.eventPreviewInput.documentType;
  }

  get previewTitle() {
    switch (this.preiviewType) {
      case this.invoiceDocumentType:
        return 'POE Invoice Preview';
      case this.rollCallDocumentType:
        return 'Roll Call Preview';
      case this.skuPurchaseTrialDocumentType:
        return 'SKU Purchase/Trial Activation Preview';
      case this.savedPoeDocumentType:
        return 'Saved Document Preview';
      case this.daPOETemplateDocumentType:
        return 'Deal Association Preview';
      case this.sowPreviewType:
        return 'Statement of Work Preview';
      default:
        return (
          this.eventPreviewInput.documentType
            .replace(/([A-Z])/g, ' $1')
            .trim() + ' POE Preview'
        );
    }
  }

  get rejectButtonDisabled() {
    return (
      this.disableAcceptRejectButtons &&
      this.preiviewType == this.invoiceDocumentType
    );
  }

  get acceptButtonDisabled() {
    return (
      this.disableAcceptRejectButtons &&
      this.preiviewType == this.invoiceDocumentType
    );
  }

  get showApproveButton() {
    return (
      this.showApproveDeny && this.preiviewType != this.savedPoeDocumentType
    );
  }

  get showRejectButton() {
    return (
      this.showApproveDeny && this.preiviewType != this.savedPoeDocumentType
    );
  }

  public readonly hasAdditionalNotesSection = true;

  showPreview(eventId) {
    this.canShowEventPreviewModel = true;
    this.index =
      this.eventPreviewInput.eventId === eventId
        ? this.eventPreviewInput.previewFileIndex
        : 0;
    this.showApproveDeny = true;
    this.eventRawData = [];
    this.showApproveRejectLoadder = false;
    this.eventId = eventId;
    this.getEventDetails(eventId);
  }

  closePreview() {
    this.canShowEventPreviewModel = false;

    if (!this.showApproveDeny) {
      this.reLoadList.emit(true);
    }

    this.closePreviewModal.emit(false);
  }

  checkForPrevious() {
    return !(this.eventIndex == 0);
  }
  checkForNext() {
    return !(this.eventIndex == this.eventIdList.length - 1);
  }

  onPreviousClick() {
    this.canShowEventPreviewModel = false;
    const eventId = this.eventIdList[--this.eventIndex];
    this.eventId = eventId;
    this.approvedCustomersList =
      (this.eventPreviewInput.eventCustomers &&
        this.eventPreviewInput.eventCustomers.find(
          x => x.eventId == this.eventId
        ) &&
        this.eventPreviewInput.eventCustomers
          .find(x => x.eventId == this.eventId)
          ?.eventCustomers.filter(
            cus =>
              cus.eventCustomerValidationStatusId ==
              EventCustomerValidationStatus.Approved
          )
          .map(cus => cus.customerName)) ||
      [];
    this.showPreview(eventId);
  }

  onNextClick() {
    this.canShowEventPreviewModel = false;
    const eventId = this.eventIdList[++this.eventIndex];
    this.eventId = eventId;
    this.showPreview(eventId);
    this.approvedCustomersList =
      (this.eventPreviewInput.eventCustomers &&
        this.eventPreviewInput.eventCustomers.find(
          x => x.eventId == this.eventId
        ) &&
        this.eventPreviewInput.eventCustomers
          .find(x => x.eventId == this.eventId)
          ?.eventCustomers.filter(
            cus =>
              cus.eventCustomerValidationStatusId ==
              EventCustomerValidationStatus.Approved
          )
          .map(cus => cus.customerName)) ||
      [];
  }

  onDenyOpen() {
    this.invoiceRejectionModalDisplay = true;
    this.getInvoiceRejectionReasonList();
  }

  getEventDocumentStatuses() {
    this.eventEditService.getEventDocumentStatuses().subscribe(result => {
      this.eventDocumentStatuses = result;
    });
  }

  getInvoiceRejectionReasonList() {
    this.eventEditService
      .getEventDocumentRejectionReasons()
      .subscribe(result => {
        this.invoiceRejectionList = result.filter(
          x => x.eventDocumentTypeId === this.eventDocumentTypeId
        );
      });
  }

  getEventDetails(eventId): void {
    this.hasPreviewDataLoaded = false;

    this.eventPreviewData = new EventPoeDocument();
    this.eventPreviewData.eventId = eventId;
    this.eventDocumentTypeId = NaN;
    this.eventEditService.getEventDocuments(eventId).subscribe(result => {
      this.eventDocuments = result;
      let doc;

      if (this.preiviewType != this.savedPoeDocumentType) {
        if (this.eventPreviewInput.isSavedDocumentPreview) {
          doc = this.eventDocuments.documentHistories.find(
            x => x.fileName === this.eventPreviewInput.fileName
          );
        } else {
          doc = this.eventDocuments.documents.find(
            x => x.documentType === this.preiviewType
          );
        }
        this.documentStatus = doc.documentStatus;
        this.documentUploadedDate = doc.uploadDate;
        this.eventPreviewData.fileName = doc.fileName;
        this.eventPreviewData.documentType = 'POEInvoice';
        this.eventDocumentTypeId = doc.eventDocumentTypeId;
        this.eventRegistrationDocumentId = doc.eventRegistrationDocumentId;
      }
      this.eventEditService
        .getEventDocumentPreviewDetails(
          eventId,
          doc.eventRegistrationDocumentId
        )
        .subscribe(details => {
          this.eventRawData = this.getRawDataBinded(details);
          this.hasPreviewDataLoaded = true;
          this.disableAcceptRejectButtons = details.disableButton || false;
        });
    });
  }
  getRawDataBinded(
    eventPreviewDetails: EventPreviewDetails
  ): DocumentRawData[] {
    return RawDocumentDataConfig.map(con => {
      const dr: DocumentRawData = {
        label: '',
        value: '',
        type: '',
        isHidden: false
      };

      switch (con.key) {
        case 'eventTargetProductName': {
          dr.isHidden =
            !eventPreviewDetails['isMultiTargetProductSupported'] ||
            this.preiviewType == this.daPOETemplateDocumentType;
          dr.value = eventPreviewDetails[con.key];
          break;
        }
        case 'documentStatus': {
          dr.value = this.documentStatus;
          break;
        }
        case 'approvedCustomersList': {
          dr.isHidden = !(
            this.preiviewType == this.skuPurchaseTrialDocumentType &&
            this.preiviewType != this.savedPoeDocumentType &&
            this.approvedCustomersList.length
          );
          dr.value = this.approvedCustomersList;
          break;
        }
        case 'engagementID': {
          dr.isHidden = !(this.preiviewType == this.daPOETemplateDocumentType);
          dr.value = eventPreviewDetails.eventID;
          break;
        }
        case 'eventID': {
          dr.isHidden = this.preiviewType == this.daPOETemplateDocumentType;
          dr.value = eventPreviewDetails[con.key];
          break;
        }
        case 'programType': {
          dr.isHidden = !(this.preiviewType == this.daPOETemplateDocumentType);
          dr.value = eventPreviewDetails[con.key];
          break;
        }
        case 'dayExpiration90': {
          dr.isHidden = this.preiviewType == this.daPOETemplateDocumentType;
          dr.value = eventPreviewDetails[con.key];
          break;
        }
        case 'dayExpiration60': {
          dr.isHidden = !(this.preiviewType == this.daPOETemplateDocumentType);
          dr.value = this.addDays(
            new Date(eventPreviewDetails.registrationDate),
            60
          );
          break;
        }
        case 'qualifiedAmount': {
          dr.value =
            this.preiviewType == this.daPOETemplateDocumentType
              ? '$0'
              : eventPreviewDetails[con.key];
          break;
        }
        case 'customerStatusCounts': {
          dr.isHidden = eventPreviewDetails.isOneToMany == false;
          const approvedCount =
            eventPreviewDetails.customerStatusCounts['Approved'] || 0;
          const pendingCount =
            eventPreviewDetails.customerStatusCounts['Pending'] || 0;
          const rejectedCount =
            eventPreviewDetails.customerStatusCounts['Rejected'] || 0;

          dr.value = [
            `Approved - ${approvedCount}`,
            `Pending - ${pendingCount}`,
            `Rejected - ${rejectedCount}`
          ];
          break;
        }
        default: {
          dr.value = eventPreviewDetails[con.key];
        }
      }
      dr.label = con.label;
      dr.type = con.type;
      return dr;
    });
  }
  submitForApproval() {
    this.isApproveReject = true;
    this.showApproveRejectLoadder = true;
    const eventRegistrationDocumentStatusRequests: EventRegistrationDocumentStatusRequest[] =
      [];

    const request: EventRegistrationDocumentStatusRequest = {
      eventRegistrationDocumentId: this.eventRegistrationDocumentId,
      eventDocumentStatusId:
        this.eventDocumentStatuses.find(x => x.name === 'Completed')
          ?.eventDocumentStatusId || -1,
      eventDocumentRejectionReasonIds: []
    };

    eventRegistrationDocumentStatusRequests.push(request);

    const updateRequest: UpdateEventDocumentsStatusRequest = {
      eventRegistrationDocumentStatusRequests:
        eventRegistrationDocumentStatusRequests
    } as any;

    this.eventEditService.updateEventDocumentsStatus(updateRequest).subscribe(
      () => {
        this.showApproveRejectLoadder = false;
        this.showApproveDeny = false;
        this.documentStatus = 'Completed';
        this.showMessage(this.aprrovedMessage);
        this.isApproveReject = false;
      },
      error => {
        this.showApproveRejectLoadder = false;
        this.showMessage(error.error.errorInfo, true);
        this.isApproveReject = false;
      }
    );
  }

  rejectDocument(reason) {
    this.showApproveRejectLoadder = true;
    this.isApproveReject = true;
    const eventRegistrationDocumentStatusRequests: EventRegistrationDocumentStatusRequest[] =
      [];

    const request: EventRegistrationDocumentStatusRequest = {
      eventRegistrationDocumentId: this.eventRegistrationDocumentId,
      eventDocumentStatusId:
        this.eventDocumentStatuses.find(x => x.name === 'Rejected')
          ?.eventDocumentStatusId || -1,
      eventDocumentRejectionReasonIds: []
    };

    if (reason.selectedReasons) {
      reason.selectedReasons.forEach(element => {
        request.eventDocumentRejectionReasonIds.push(
          element.eventDocumentRejectionReasonId
        );
      });
    }

    eventRegistrationDocumentStatusRequests.push(request);

    const updateEventDocumentsStatusRequest: UpdateEventDocumentsStatusRequest =
      {
        eventRegistrationDocumentStatusRequests:
          eventRegistrationDocumentStatusRequests,
        additionalRejectionReason: reason.additionalNotes
      };

    this.eventEditService
      .updateEventDocumentsStatus(updateEventDocumentsStatusRequest)
      .subscribe(
        () => {
          this.showApproveDeny = false;
          this.documentStatus = 'Rejected';
          this.showMessage(this.rejectedMessage);
          this.isApproveReject = false;
        },
        error => {
          this.showMessage(error.error.errorInfo, true);
          this.isApproveReject = false;
        }
      );
    this.closeDeclineModal();
  }

  closeDeclineModal() {
    this.invoiceRejectionModalDisplay = false;
  }

  get rejectedMessage() {
    switch (this.preiviewType) {
      case this.invoiceDocumentType:
        return 'POE Invoice rejected.';
      case this.rollCallDocumentType:
        return 'Roll call document rejected.';
      case this.skuPurchaseTrialDocumentType:
        return 'SKU/Purchase Trial Activation document rejected.';
      case this.daPOETemplateDocumentType:
        return 'Deal Association POE document rejected';
      case this.sowPreviewType:
        return 'Statement of Work document rejected';
      default:
        return (
          this.eventPreviewInput.documentType
            .replace(/([A-Z])/g, ' $1')
            .trim() + ' document rejected'
        );
    }
  }

  get aprrovedMessage() {
    switch (this.preiviewType) {
      case this.invoiceDocumentType:
        return 'POE Invoice approved.';
      case this.rollCallDocumentType:
        return 'Roll call document approved.';
      case this.skuPurchaseTrialDocumentType:
        return 'SKU/Purchase Trial Activation document approved.';
      case this.daPOETemplateDocumentType:
        return 'Deal Association POE document approved';
      case this.sowPreviewType:
        return 'Statement of Work document approved';
      default:
        return (
          this.eventPreviewInput.documentType
            .replace(/([A-Z])/g, ' $1')
            .trim() + ' document approved'
        );
    }
  }

  showMessage(message: string, isError?: boolean) {
    this.msgsUsageDetails = [];
    this.msgsUsageDetails.push({
      severity: !isError ? 'success' : 'error',
      detail: message
    });
  }

  confirmClick(data) {
    this.rejectDocument(data);
  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }
}
